import React from 'react';
import { useHistory } from 'react-router-dom';
import { createQueryString } from 'utils';

/**
 * Set/Update history's search property.
 * Use it as React hook on the page where you need to set/update history's search property.
 * @example
 * const MyPage = (props) => {
 *   useUpdateHistorySearch(searchQueryParams);
 *
 *   ... your code here
 *
 *   return (
 *    <div>My Page</div>
 *   );
 * };
 * @returns {[string, function]} - array of queryString and function
 */
export const useUpdateHistorySearch = (searchQueryParams = {}, shouldHistoryPush = false) => {
  const [historyPush, setHistoryPush] = React.useState(shouldHistoryPush);
  const [query, updateQuery] = React.useState(createQueryString(searchQueryParams));
  const [keepState, updateKeepState] = React.useState(true);
  const [forceUpdate, setForceUpdate] = React.useState(false);
  const history = useHistory();

  const setQuery = (newSearchQueryParams, options = {}) => {
    const { shouldHistoryPush = false, keepState = true, shouldUpdate = false } = options;

    updateKeepState(keepState);
    setHistoryPush(shouldHistoryPush);
    setForceUpdate(shouldUpdate);

    updateQuery(createQueryString(newSearchQueryParams));
  };

  React.useEffect(() => {
    history[historyPush ? 'push' : 'replace']({
      ...history.location,
      search: query,
      state: keepState ? history.location.state : {},
    });
  }, [query]);

  React.useEffect(() => {
    if (forceUpdate) {
      history[historyPush ? 'push' : 'replace']({
        ...history.location,
        search: query,
        state: keepState ? history.location.state : {},
      });
      setForceUpdate(false);
    }
  }, [forceUpdate]);

  return [query, setQuery];
};

export default useUpdateHistorySearch;
